import { Circle } from 'rc-progress';
import { useState } from 'react';


import established from '../../../assets/about/established.svg'
import global from '../../../assets/about/global.svg'
import happy from '../../../assets/about/happy.svg'
import projects from '../../../assets/about/projects.svg'
import team from '../../../assets/about/team.svg'


const Why = () => {


    const cardsData = [
        {
            title: 'Happy Clients',
            img: happy,
            roundColor: 'rgb(80, 89, 172)',
            percent: 20,
            textColor: 'text-red-500',
            num: 150
        },
        {
            title: 'Team',
            img: team,
            roundColor: 'rgb(20, 160, 193)',
            percent: 40,
            textColor: 'text-orange-500',
            num: 50
        },
        {
            title: 'Projects',
            img: projects,
            roundColor: 'rgb(103, 188, 68)',
            percent: 60,
            textColor: 'text-cyan-600',
            num: 80

        },
        {
            title: 'Established',
            img: established,
            roundColor: 'rgb(79, 124, 170)',
            percent: 80,
            textColor: 'text-blue-600',
            num: 2022

        },
        {
            title: 'Global Office',
            img: global,
            roundColor: 'rgb(0, 205, 153)',
            percent: 100,
            textColor: 'text-green-600',
            num: 2

        },
    ]


    return (
        <div className='max-w-screen-2xl mx-auto py-5 md:py-8 px-2 md:px-10'>

            <div>
                <h1
                    className='text-xl dark:text-white md:text-2xl font-bold text-center'
                >
                    Why <span className='text-red-500'>CodeZone?</span>
                </h1>
                <p className='text-center text-[15px] my-2 mx-auto md:max-w-[700px] dark:text-white'>
                    We recruit, train, manage the resources well-versed in the latest tech stacks.
                </p>
            </div>


            <div className='my-7 md:mt-12 flex justify-center flex-wrap gap-4 lg:gap-0 mx-auto'>
                {cardsData.map((item, i) => (
                    <div className='flex' key={i}>
                        <div className='w-[120px] md:w-[160px] '>
                            <div className='relative hover:scale-105 group duration-700 cursor-pointer' >
                                <div className='absolute inset-0 flex items-center justify-center' >
                                    <div className='h-[110px] relative md:h-[160px] w-[110px] md:w-[160px] p-2.5 flex rounded-full bg-white shadow-md '>
                                        <div className='flex flex-col gap-1 justify-center items-center bg-[#f2f7fb] shadow-lg h-full w-full rounded-full'>
                                            <img src={item.img} alt="img" className='h-[25px] md:h-[50px]' />
                                            <h2
                                            style={{
                                                color : `${item.roundColor}`
                                            }}
                                            className='font-bold text-sm sm:text-xl'
                                            >
                                                {item.num}+
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                                <Circle
                                    percent={100}
                                    strokeWidth={3.5}
                                    strokeColor={item.roundColor}
                                    className='h-[120px] md:h-[160px] '
                                    trailColor='transparent'

                                    style={{ transform: 'rotate(0deg)' }}
                                />
                            </div>
                            <div>
                                <p className='mt-3 font-bold text-[14px] md:text-sm text-center dark:text-white'>
                                    {item.title}
                                </p>
                            </div>
                        </div>
                        {i < 4 && (

                            <div className='h-[150px] hidden lg:flex items-center'>
                                <div className={`h-[7px] w-[50px]`}
                                    style={{
                                        backgroundColor: `${item.roundColor}`
                                    }}
                                />
                            </div>
                        )}
                    </div>
                ))}
            </div>



        </div>
    )
}

export default Why